import BlogTemplate from './BlogTemplate';

// Content type -> page template. All templates reuse ContentRenderer for the body;
// add CaseStudyTemplate, ProductTemplate, ... here when their layout genuinely differs.
const templates = {
  blog: BlogTemplate,
};

export function getTemplate(type) {
  return templates[type] || BlogTemplate;
}
